module.exports = __webpack_public_path__ + "media/images/soar/site/highlight_02-bc1be9d374261ac2dde3264238e0173e.svg";